import { render, staticRenderFns } from "./DPL.vue?vue&type=template&id=12bcbbce&scoped=true"
import script from "./DPL.vue?vue&type=script&lang=js"
export * from "./DPL.vue?vue&type=script&lang=js"
import style0 from "./DPL.vue?vue&type=style&index=0&id=12bcbbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bcbbce",
  null
  
)

export default component.exports